export const backendAction = [
    {
        value:'1',
        label:'新增请求参数',
    },
    {
        value:'2',
        label:'删除请求参数',
    },
    {
        value:'3',
        label:'修改请求参数',
    },
    {
        value:'4',
        label:'修改返回值',
    },
    {
        value:'5',
        label:'复制接口',
    },
    {
        value:'6',
        label:'修改控制器',
    },
    {
        value:'7',
        label:'接口报错修复',
    },
    {
        value:'8',
        label:'增加操作逻辑',
    },
    {
        value:'9',
        label:'新增接口',
    },
]


